import { Component, EventEmitter, Input, Output, OnInit } from '@angular/core';

@Component({
  selector: 'app-invoice',
  templateUrl: './invoice.component.html',
  styleUrls: ['./invoice.component.css']
})
export class InvoiceComponent implements OnInit {
  private _rowData: any;
  private _value: any;

  @Output() download = new EventEmitter<any>();

  @Input()
  set rowData(value: any) {
    this._rowData = value;
    this.updateDisableState();
  }
  get rowData(): any {
    return this._rowData;
  }

  @Input()
  set value(val: any) {
    this._value = val;
    this.updateDisableState();
  }
  get value(): any {
    return this._value;
  }

  isDisable: boolean = false;

  ngOnInit() {
    this.updateDisableState();
  }

  private updateDisableState() {
    const data = this._rowData || this._value;
    this.isDisable = data?.status === 'En cours';
   // console.log('Status:', data?.status, 'isDisable:', this.isDisable);
  }

  onDownload() {
    const data = this._rowData || this._value;
    //console.log("row Data", data?.status);
    this.download.emit(data);
  }
}

/*import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-invoice',
  templateUrl: './invoice.component.html',
  styleUrls: ['./invoice.component.css']
})
export class InvoiceComponent {
  private _rowData: any;
  @Output() download = new EventEmitter<any>();
  @Input()
  set rowData(value: any) {
    this._rowData = value;
    // Mettre à jour isDisable selon le status
    this.isDisable = value?.status === 'En coursz'; // adapte la condition si besoin
  }
  get rowData(): any {
    return this._rowData;
  }
  isDisable: boolean = false;
  onDownload() {
    console.log("row Da",this.rowData.status);

    this.download.emit(this.rowData); // rowData est injecté via @Input()
  }
}*/
